import { LocalizedLink } from "@/i18n/language";
import { useTranslation } from "react-i18next";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageHeader from "@/components/feature/PageHeader";
import BookingCompanyNotice from "@/components/feature/BookingCompanyNotice";
import GalleryGrid from "@/components/feature/GalleryGrid";
import { tourGalleryImages } from "./gallery-data";
import { img } from "@/lib/images";
import { useGalleryCaptions } from "@/hooks/useGalleryCaptions";

export default function TourInfoPage() {
  const { t, i18n } = useTranslation();
  const isDe = i18n.language.startsWith("de");
  const galleryImages = useGalleryCaptions("tour-info", tourGalleryImages);

  return (
    <div className="bg-background-50 text-foreground-950 min-h-screen">
      <Navbar />
      <main>
        <PageHeader
          eyebrow={t("tour_info_eyebrow")}
          title={t("tour_info_title")}
          subtitle={t("tour_info_intro")}
          image={img("activities/tour-info/header-tourinfo-01.jpg")}
          imageAlt="Bali tours with Villa Kompiang"
        />

        <section className="py-12 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">
              {t("tour_info_heading_1")}
            </h2>
            <div className="w-10 h-0.5 bg-accent-500 mb-6"></div>
            <div className="space-y-6">
              <p className="text-foreground-700 leading-relaxed">
                {t("tour_info_p1")}
              </p>
              <p className="text-foreground-700 leading-relaxed">
                {t("tour_info_p2")}
              </p>
              <p className="text-foreground-700 leading-relaxed">
                {t("tour_info_p3")}
              </p>
              <p className="text-foreground-700 leading-relaxed">
                {t("tour_info_p4")}
              </p>
              <p className="text-foreground-700 leading-relaxed">
                {t("tour_info_p5")}
              </p>
              <p className="text-foreground-700 leading-relaxed">
                {t("tour_info_p6")}
              </p>
            </div>

            <div className="flex flex-col lg:flex-row gap-6 lg:gap-8 mt-10">
              <div className="lg:w-5/12 shrink-0">
                <div className="rounded-lg overflow-hidden border border-background-200">
                  <img
                    src={img("activities/tour-info/tour-info-cars-01.jpg")}
                    alt="unsere Autoauswahl für Bali Ausflüge: Mitsubishi Pajero, Toyota Kijang, Suzuki Escudo, VW 181 Kübelwagen"
                    className="w-full h-auto object-cover"
                  />
                </div>
              </div>
              <div className="lg:w-7/12">
                <p className="font-semibold text-foreground-950 mb-4">
                  {t("tour_info_car_intro")}
                </p>
                <p className="text-foreground-700 leading-relaxed">
                  {t("tour_info_car_vw")}
                </p>
              </div>
            </div>
            <div className="mt-8 space-y-6">
              <p className="text-foreground-700 leading-relaxed">
                {t("tour_info_car_suzuki")}
              </p>
              <p className="text-foreground-700 leading-relaxed">
                {t("tour_info_car_toyota")}
              </p>
              <p className="text-foreground-700 leading-relaxed">
                {t("tour_info_car_mitsubishi")}
              </p>
            </div>
          </div>
        </section>

        {/* Gallery */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <div className="text-center max-w-3xl mx-auto mb-4">
              <div className="eyebrow-brand text-xs uppercase tracking-[0.35em] mb-3">
                — {t("gallery_tours_eyebrow")} —
              </div>
              <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 leading-[1.12] tracking-tight">
                {t("gallery_tours_title")}
              </h2>
            </div>
            <p className="text-center text-sm text-foreground-600 mb-10">
              {t("gallery_tours_hint")}
            </p>
            <GalleryGrid images={galleryImages} />
          </div>
        </section>

        <section className="py-12 md:py-14 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
                  {t("tour_info_cta_title")}
                </h2>
                <p className="mt-2 text-foreground-700 text-sm">
                  {t("tour_info_cta_sub")}
                </p>
              </div>
              <LocalizedLink
                to="/booking"
                className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-100 text-background-50 hover:text-foreground-950 px-7 py-3.5 rounded-md font-medium whitespace-nowrap cursor-pointer transition-colors"
              >
                <i className="ri-calendar-check-line"></i>
                {t("nav_book_now")}
              </LocalizedLink>
            </div>
            <BookingCompanyNotice isDe={isDe} />
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}